/* eslint-disable */
import esriConfig from "@arcgis/core/config";
import "./App.scss";
import { LoadingContextProvider } from "context/LoadingContext";
import { EsriUrlsContextProvider } from "context/esriUrlsContext";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { LookupsContextProvider } from "context/lookupsContext";
import Loader from "components/Loader";
import ProtectedRoutes from "components/ProtectedRoutes";
import Auth from "pages/Auth";
import Home from "pages/Home";
import { MapContextProvider } from "context/mapContext";
import { ResponsiveContextProvider } from "context/responsiveContext";
import esriId from "@arcgis/core/identity/IdentityManager";
import { useAuth } from "context/auth";
import { useEffect } from "react";
import Cookies from 'js-cookie';

function App() {
  const [auth] = useAuth();
  useEffect(() => {
    if (auth?.esriToken) {
      Cookies.set('esri_aopc', auth.esriToken, {
        expires: 7, 
        path: '/',
        secure: true, 
        sameSite: 'Lax'
      });
  
      Cookies.set('esri_locale', 'en', {
        expires: 7, 
        path: '/',
        secure: true,
        sameSite: 'None' 
      });

      const currentDate = new Date();
      function addOneMonth(date) {
        date.setMonth(date.getMonth() + 1);
        return date;
      }    
      const esriJSAPIOAuthValue = {
        "/": {
            "https://sp.pdtra.gov.jo/portal": {
                "appId": "dashboards",
                "codeVerifier": null,
                "expires": addOneMonth(currentDate).getTime(),
                "refreshToken": null,
                "ssl": true,
                "stateUID": null,
                "token": auth.esriToken,
                "userId": 'portaladmin'
            }
        }
      };
      sessionStorage.setItem('esriJSAPIOAuth', JSON.stringify(esriJSAPIOAuthValue));
    }
  }, [auth]);
    
  useEffect(() => {
    if (auth?.esriToken) {
      const rInfo = {
        expires: auth.esriExpires,
        server: `${process.env.REACT_APP_SERVICE_PORTAL}/sharing/rest`,
        token: auth.esriToken,
        // userId: localStorage.getItem("username"),
      };
      esriId.registerToken(rInfo);
      esriConfig.portalUrl = process.env.REACT_APP_SERVICE_PORTAL;
      esriId.on("dialog-create", () => {
        esriId.dialog.when(() => {
          const dialogHtml = esriId.dialog.container;
          const cancelBtn =
            dialogHtml.childNodes[0].childNodes[2].childNodes[0].childNodes[3]
              .childNodes[1];
          cancelBtn.click();
          NotificationManager.error("حدث خطأ ما");
        });
      });
    }
  }, [auth.token]);
  return (
    <EsriUrlsContextProvider>
      <LoadingContextProvider>
        <LookupsContextProvider>
          <ResponsiveContextProvider>
            <Loader />
            <NotificationContainer />
            <Routes>
              <Route path="/auth/*" element={<Auth />} />
              {/* <Route
              path="/*"
              element={
                <MapContextProvider>
                  <Home />
                </MapContextProvider>
              }
            /> */}
              <Route element={<ProtectedRoutes />}>
                <Route
                  path="/*"
                  element={
                    <MapContextProvider>
                      <Home />
                    </MapContextProvider>
                  }
                />
                {/* <Route path="/*" element={<Home />} /> */}
                {/* <Route path="*" element={<RestRoutes />} /> */}
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </ResponsiveContextProvider>
        </LookupsContextProvider>
      </LoadingContextProvider>
    </EsriUrlsContextProvider>
  );
}
export default App;
